<div class="card">
    <div class="card-header">
        <h2>Tags</h2>
    </div>
    <div><!--suppress HtmlUnknownAttribute -->
        <tag-input (onAdd)="onAddTag($event)"
                   (onRemove)="onRemoveTag($event)"
                   [(ngModel)]="tags"
                   [class.left-pad]="!ifTagsAreFiltering"
                   theme="minimal">

            <tag-input-dropdown
                [autocompleteItems]="tags"
                [keepOpen]="true"
                [showDropdownIfEmpty]="true"
            >
                <ng-template let-index="index" let-item="item">
                    <div class="tag-input-dropdown-item">
                        <i [style.color]="tagTypeColors[item.display] || '#ccc'" class="fa fa-tag mr-1"></i>
                        {{ item.display }}
                    </div>
                </ng-template>

            </tag-input-dropdown>
        </tag-input>
    </div>
</div>
